import { type DrawerPlacementType, useBreakpoint } from '@palmetto/palmetto-components';

import type { ParentStyles } from './useParentDivLayoutStyles';

export const DRAWER_WIDTH = 400 as const;
const MAX_WINDOW_PUSH_WIDTH = 2140 as const;

export function useGetDrawerMarginStyles(
  parentStyles: ParentStyles,
  isDrawerOpen: boolean,
  placement: DrawerPlacementType = 'right',
): string {
  const breakpoints = useBreakpoint();
  const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;

  if (!isDrawerOpen || breakpoints.isPhone || windowWidth > MAX_WINDOW_PUSH_WIDTH) {
    return '0';
  }

  const parentMarginPadding = parentStyles.reduce(
    (
      acc: number,
      style: { marginRight?: string; paddingRight?: string; marginLeft?: string; paddingLeft?: string },
    ) => {
      if (placement === 'right') {
        return acc + parseFloat(style?.marginRight || '0') + parseFloat(style?.paddingRight || '0');
      } else if (placement === 'left') {
        return acc + parseFloat(style.marginLeft || '0') + parseFloat(style.paddingLeft || '0');
      }
      return acc;
    },
    0,
  );

  return `calc(${DRAWER_WIDTH}px - ${parentMarginPadding}px + 2rem)`;
}
